import React, { useState } from 'react';
import { 
  Users, Activity, DollarSign, BarChart2, 
  LogOut, Settings as SettingsIcon, CreditCard, Gift, PieChart, LayoutDashboard, Megaphone
} from 'lucide-react';
import { useApp } from '../../context/AppContext'; // 🔥 Importado para el Logout

// Secciones
import Dashboard from "./Dashboard";
import UsersSection from "./Users";
import TransactionsSection from "./Transactions";
import RatesSection from "./Rates";
import ReportsSection from "./Reports";
import Settings from "./Settings";
import PaymentMethods from "./PaymentMethods";
import ReferralsSection from "./Referrals";
import MarketingPush from "./MarketingPush";

const AdminPanel = () => {
  const { logout } = useApp(); // 🔥 Obtenemos la función de cerrar sesión
  const [activeSection, setActiveSection] = useState('dashboard');

  const sections = [
    { key: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard className="w-5 h-5" /> },
    { key: 'users', label: 'Usuarios', icon: <Users className="w-5 h-5" /> },
    { key: 'transactions', label: 'Transacciones', icon: <DollarSign className="w-5 h-5" /> },
    { key: 'payments', label: 'Métodos de Pago', icon: <CreditCard className="w-5 h-5" /> },
    { key: 'rates', label: 'Tasas', icon: <BarChart2 className="w-5 h-5" /> },
    { key: 'marketing', label: 'Campañas Push', icon: <Megaphone className="w-5 h-5" /> },
    { key: 'referrals', label: 'Referidos', icon: <Gift className="w-5 h-5" /> },
    { key: 'reports', label: 'Reportes', icon: <PieChart className="w-5 h-5" /> },
    { key: 'settings', label: 'Configuración', icon: <SettingsIcon className="w-5 h-5" /> },
  ];

  const renderSection = () => {
    switch (activeSection) {
      case 'dashboard': return <Dashboard />;
      case 'users': return <UsersSection />;
      case 'transactions': return <TransactionsSection />;
      case 'payments': return <PaymentMethods />;
      case 'rates': return <RatesSection />;
      case 'marketing': return <MarketingPush />;
      case 'referrals': return <ReferralsSection />;
      case 'reports': return <ReportsSection />;
      case 'settings': return <Settings />;
      default: return <Dashboard />;
    }
  };

  return (
    <div className="min-h-screen flex bg-[#f8fafc] font-sans">
      
      {/* SIDEBAR PREMIUM */}
      <aside className="w-72 bg-white shadow-2xl shadow-slate-200/50 flex flex-col sticky top-0 h-screen z-20">
        <div className="p-8 border-b border-slate-50">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-200">
               <span className="text-white font-black text-xl italic">R</span>
            </div>
            <h1 className="font-black text-xl text-slate-800 tracking-tighter leading-none">
                ADMIN <span className="text-blue-600 block text-[10px] uppercase tracking-[0.3em] mt-1">v2.0 Premium</span>
            </h1>
          </div>
        </div>

        <nav className="flex-1 p-6 space-y-2 overflow-y-auto">
          <p className="text-[10px] font-black text-slate-300 uppercase tracking-[0.2em] mb-4 ml-2">Menú Principal</p>
          {sections.map(sec => (
            <button
              key={sec.key}
              className={`flex items-center gap-4 w-full p-4 rounded-2xl text-sm transition-all duration-300 group ${
                activeSection === sec.key
                  ? 'bg-blue-600 text-white shadow-xl shadow-blue-100 font-black'
                  : 'text-slate-400 hover:bg-slate-50 hover:text-slate-800 font-bold'
              }`}
              onClick={() => setActiveSection(sec.key)}
            >
              <span className={`transition-transform duration-300 ${activeSection === sec.key ? 'scale-110' : 'group-hover:scale-110'}`}>
                {sec.icon}
              </span> 
              {sec.label}
            </button>
          ))}
        </nav>

        {/* BOTÓN CERRAR SESIÓN */}
        <div className="p-6 border-t border-slate-50">
            <button 
                onClick={logout}
                className="flex items-center gap-4 w-full p-4 text-red-500 hover:bg-red-50 rounded-2xl font-black text-sm uppercase tracking-widest transition-all duration-300 active:scale-95"
            >
                <LogOut className="w-5 h-5" />
                Cerrar sesión
            </button>
        </div>
      </aside>

      {/* MAIN CONTENT CON HEADER DINÁMICO */}
      <main className="flex-1 overflow-y-auto">
        {/* Header Superior del Main */}
        <header className="bg-white/80 backdrop-blur-md sticky top-0 z-10 border-b border-slate-100 px-12 py-6 flex justify-between items-center">
            <div>
                <h2 className="text-2xl font-black text-slate-800 tracking-tighter capitalize">{activeSection}</h2>
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Panel de Control / {activeSection}</p>
            </div>
            <div className="flex items-center gap-4">
                <div className="text-right">
                    <p className="text-sm font-black text-slate-800">Admin Central</p>
                    <p className="text-[10px] font-bold text-green-500 uppercase tracking-widest">Sistema Online</p>
                </div>
                <div className="w-12 h-12 bg-slate-100 rounded-2xl border-2 border-white shadow-sm flex items-center justify-center text-xl">
                    ⚡
                </div>
            </div>
        </header>

        <div className="p-12 max-w-7xl mx-auto">
          {/* Animación suave al cambiar de sección */}
          <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
            {renderSection()}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminPanel;

